import { render, staticRenderFns } from "./MiddlePage.vue?vue&type=template&id=290c7ac3&"
import script from "./MiddlePage.vue?vue&type=script&lang=js&"
export * from "./MiddlePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports